import { Suspense, lazy } from "react";
import DashboardLayout from "../layouts/dashboard";
import { PATH_LEADS } from "./paths";
import { Outlet } from "react-router-dom";
import AuthGuard from "../guards/AuthGuard";

const Leads = lazy(() => import("@pages/leads"));
const LeadDetails = lazy(() => import("@pages/leads/lead-details/lead.details.container"));

const leadRoutes = [
  {
    path: PATH_LEADS,
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      {
        element: <Leads />,
        index: true,
      },
      {
        path: ":leadId",
        element: <LeadDetails />,
      },
    ],
  },
];

export default leadRoutes;
